import ApiService from "../../api/api.service";
import { GET_DEMAT_FORM, GET_TRADING_FORM, GET_EINSURANCE_FORM, SAVE_ACCOUNTS_FORM_DETAIL, 
	GET_ACCOUNTS_FORM_DETAIL, GET_EDIT_ACCOUNTS_FORM, UPDATE_ACCOUNTS_FORM, GET_DP_NAME_DATA, DELETE_ACCOUNT_FORM } from "../actions.type";

const getDefaultAccountsState = () => {
	return {
		dematForm: {},
		tradingForm: {},
		einsuranceForm: {},
		saveAccount: {},
		AccountFormDetail: {},
		editAccountForm: {},
		updateAccountForm: {},
		dpName:{},
		deleteAccountForm: {},
	}
};

const state = getDefaultAccountsState();

const getters = {

	getDematForm (state) {
		return state.dematForm;
	},
	getTradingForm (state) {
		return state.tradingForm;
	},
	getEInsuranceForm (state) {
		return state.einsuranceForm;
	},
	getSaveAccount (state) {
		return state.saveAccount;
	},
	getAccountFormDetail (state) {
		return state.AccountFormDetail;
	},
	getEditAccountForm (state) {
		return state.editAccountForm;
	},
	getUpdateAccountForm (state) {
		return state.updateAccountForm;
	},
	getDpNameData (state) {
		return state.dpName;
	},
	getDeleteAccountForm(state) {
		return state.deleteAccountForm;
	},
};

const mutations = {

	setDematForm (state, data) {
		state.dematForm = data
	},
	setTradingForm (state, data) {
		state.tradingForm = data
	},
	setEInsuranceForm (state, data) {
		state.einsuranceForm = data
	},
	setSaveAccount (state, data) {
		state.saveAccount = data
	},
	setAccountFormDetail (state, data) {
		state.AccountFormDetail = data
	},
	setEditAccountForm (state, data) {
		state.editAccountForm = data
	},
	setUpdateAccountForm (state, data) {
		state.updateAccountForm = data
	},
	setDpNameData (state, data) {
		state.dpName = data
	},
	setDeleteAccountForm (state, data) {
		state.deleteAccountForm = data
	},
};


const actions = {

	[GET_DEMAT_FORM](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setDematForm',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_TRADING_FORM](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setTradingForm',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_EINSURANCE_FORM](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setEInsuranceForm',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[SAVE_ACCOUNTS_FORM_DETAIL](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setSaveAccount',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_ACCOUNTS_FORM_DETAIL](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setAccountFormDetail',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_EDIT_ACCOUNTS_FORM](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setEditAccountForm',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[UPDATE_ACCOUNTS_FORM](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setUpdateAccountForm',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_DP_NAME_DATA](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setDpNameData',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[DELETE_ACCOUNT_FORM](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setDeleteAccountForm',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
};

export default {
	getters,
	actions,
	mutations,
	state
}